import { Grid } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NO_OP } from '../../../../../../misc/noOp';
import { Button } from '../../../../atomic/button';

type FormButtonAreaProps = {
  onReset: () => void;
  onSubmit?: () => void;
  saveButtonText?: string;
  resetButtonText?: string;
};

export const FormButtonArea: FC<FormButtonAreaProps> = ({
  onReset,
  onSubmit,
  saveButtonText,
  resetButtonText
}) => {
  const { t } = useTranslation('common');

  return (
    <Grid
      item
      container
      marginTop={'12px'}
      xs={12}
      columnSpacing={3}
      rowSpacing={1}
      display={'flex'}
      flexWrap={'wrap-reverse'}
      justifyContent={{
        xs: 'center',
        sm: 'flex-start'
      }}
    >
      <Grid item>
        <Button variant="secondary" onClick={onReset}>
          {resetButtonText ?? t('CANCEL')}
        </Button>
      </Grid>
      <Grid item>
        <Button type="submit" onClick={onSubmit ?? NO_OP}>
          {saveButtonText ?? t('SAVE')}
        </Button>
      </Grid>
    </Grid>
  );
};
